/* 0908 structured reader only. Never changes product data or shared collections. */
if (!customElements.get('yieon-related-ranked')) {
  customElements.define('yieon-related-ranked', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          this.load();
        }
      }, { rootMargin: '500px' });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    async read(url) {
      const response = await fetch(url, { signal: AbortSignal.timeout(15000) });
      if (!response.ok) throw new Error(`Related products HTTP ${response.status}`);
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = Array.from(document.querySelectorAll('yieon-related-ranked'))
        .find(node => node.dataset.sectionId === this.dataset.sectionId);
      if (!result) throw new Error('Related products section missing');
      return result;
    }
    async load() {
      this.dataset.state = 'loading';
      const groups = { manual: [], series: [], craft: [], category: [], platform: [] };
      const collect = root => root.querySelectorAll('template[data-candidate-id]').forEach(node => {
        if (groups[node.dataset.rank]) groups[node.dataset.rank].push(node);
      });
      const limit = Number(this.dataset.limit);
      const select = () => {
        const seen = new Set([this.dataset.productId]);
        const ranks = this.dataset.manual === 'true' ? ['manual', 'platform'] : ['series', 'craft', 'category', 'platform'];
        return ranks.flatMap(rank => groups[rank]).filter(node => {
          const id = node.dataset.candidateId;
          if (seen.has(id)) return false;
          seen.add(id); return true;
        }).slice(0, limit);
      };
      try {
        collect(this);
        const page = this.querySelector('[data-pool-page]');
        if (page) {
          if (Number(page.dataset.total) === 0) throw new Error('Related candidate collection empty');
          const currentPage = Number(page.dataset.page);
          // Include every page before ranking; first-page membership is not the full pool.
          for (let index = 1; index <= Number(page.dataset.pages); index++) {
            if (index === currentPage) continue;
            const url = new URL(window.location.href);
            url.searchParams.set('section_id', this.dataset.sectionId);
            url.searchParams.set(page.dataset.pageParam, String(index));
            collect(await this.read(url));
          }
        }
        if (select().length < limit) {
          const url = new URL(this.dataset.recommendationsUrl, window.location.origin);
          url.searchParams.set('product_id', this.dataset.productId);
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('limit', '10');
          const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          try { collect(await this.read(url)); }
          catch (error) {
            this.dataset.platformState = 'unavailable';
            console.warn('YIEON platform recommendations unavailable:', error.message);
          }
        }
        const chosen = select();
        this.querySelector('[data-ranked-grid]').replaceChildren(...chosen.map(node => node.content.cloneNode(true)));
        this.querySelector('[data-results]').hidden = chosen.length === 0;
        this.dataset.state = 'complete';
      } catch (error) {
        // Do not present a partially scanned pool as the approved ranking.
        this.dataset.state = 'error';
        console.warn('YIEON related products could not be completed:', error.message);
      }
    }
  });
}
